<div class="py-5">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1">
        <div>
          <h1 class="text-2xl font-bold mb-4">{{ 'LABELS.PRIVACY' | transloco }}</h1>
        </div>
      </div>
    </div>
  </div>

  <div class="py-10">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-1 gap-6">
        <div *ngIf="language === 'en'">
          <!-- Section 1 -->
          <section class="privacy mb-6">
            <h5 class="text-lg font-semibold mb-2">1. Overview</h5>
            <p class="text-gray-700">
              HALA Payments Company (“HALA”) is Regulated as an EMI Financial Institution by SAMA. HALA
              is keen on the user’s data and information and committed to maintaining the confidentiality and
              privacy of this data and using it to reach the desired level in providing the necessary service to
              the user in accordance with Saudi Central Bank Directions. The use of HALA’s website (the
              “WEBSITE”) and applications is considered an approval from the user to the privacy statement.
            </p>
          </section>

          <!-- Section 2 -->
          <section class="privacy mb-6">
            <h5 class="text-lg font-semibold mb-2">2. Data Collection Methods</h5>
            <p class="text-gray-700">
              Personal data is collected indirectly through cookies that are collected when you visit the
              Website (cookies).
            </p>
                    <div class="container mt-5">
              <table class="w-full table-auto border-collapse border border-gray-300">
                <thead>
                                <tr>
                                    <th class="border border-gray-300 px-4 py-2 text-center green-background" colspan="1">Cookie Key</th>
                                    <th class="border border-gray-300 px-4 py-2 text-center green-background" colspan="2">Domain</th>
                                    <th class="border border-gray-300 px-4 py-2 text-center green-background" colspan="2">Description</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of ENData">
                                    <td class="border border-gray-300 px-4 py-2 text-center" colspan="1">{{ item.cookieKey }}</td>
                                    <td class="border border-gray-300 px-4 py-2 text-center" colspan="2">{{ item.domain }}</td>
                                    <td class="border border-gray-300 px-4 py-2 text-center" colspan="2">{{ item.description }}</td>
                  </tr>
                </tbody>
              </table>
            </div>




                </section>
                <section class="privacy">
                    <h5>3. Use of Personal Data</h5>
                    <p>
              HALA personal data is used for the purposes of completing the registration process and
              improving the beneficiary's experience.
            </p>
                    <p>
                        HALA may send marketing information to its customers in relation to promotions that
                        HALA is initiating from time to time, or service offerings that are customized and related
                        to certain criteria of customers. Third-party providers will not be allowed to use our
                        market directly using your personal data in connection with other services they offer. If
                        you receive any such marketing that you have not specifically requested, you should let
                        us know to take proper action immediately.
            </p>
          </section>

                <section class="privacy">
                    <h5>4. Storage and Destruction of Personal Data</h5>
                    <p>
              HALA personal data is stored as per SAMA Regulations regarding that matter.

            </p>

          </section>

                <section class="privacy">
                    <h5>5. Legal basis for Collecting and Processing Personal Data</h5>
                    <p>
                        The collection and processing of personal data is based on the consent of the personal
                        data subject, and the personal data subject can revoke his/her consent to the collection
                        and processing of his/her personal data at any time unless there is another legal basis,
                        and to do so, he/she can contact HALA customer service (toll free number : 8003030122
                        or email: support&#64;HALA.com); or through the customer care unit in official digital
                        channels by contacting one of our customer service representatives. Also, the customer
                        will be contacted regarding his case within three (3) working days from the date of
                        receipt, unless the customer confirms that the case has been resolved by us.
                    </p>
                </section>

                <section class="privacy">
                    <h5>6. Rights of the Personal Data Subject</h5>
                    <p>
                        Our customers have all the rights to access, rectification, erasure, object, restrict
                        processing, data portability and close their HALA account(s). If they choose to close their
                        HALA account, their personal information will generally stop being visible to others on
                        our services, upon returning all HALA devices and clearing the account balance. HALA,
                        generally will delete closed account data, within 90 days of account closure, except if the
                        below circumstances apply:
                    </p>

                    <ul>
                        <li> HALA may retain your personal data even after you have closed your
                            account, to comply with local regulatory requirements; to meet with our
                            legal obligations (including law enforcement requests); to maintain cyber
                            security protection, or prevent fraud and abuse (e.g., if we have restricted
                            your account for breach of our HALA policies); and to enforce HALA’s
                            terms and conditions. Thus, HALA will retain de-personalized data after
                            your account has been closed.</li>
                        <li> Data that have shared with others or information of transactions to
                            others will remain visible even after you close your account or delete the
                            information from your own profile, noting that we do not control data
                            that other members have copied out of our services.</li>
                    </ul>

                </section>
                <section class="privacy">
                    <h5>7. Sharing/Exchanging Personal Data</h5>
                    <p>
                        By acknowledgment this statement, we may disclose your personal data to our other
                        services inside the Kingdom; and/or third parties in the following circumstances:

                    </p>

                    <ul>
                        <li> Sharing data in the case of a liquidation, merger, sale, receivership, or
                            transfer of HALA assets, to the prospective buyer of the business and their
                            advisers.</li>
                        <li> Sharing data to ensure services availability and optimization.</li>
                        <li> Sharing data with third parties that support us in providing our services
                            to you or perform certain functions on our behalf, including IT support
                            services or professional services.</li>


                        <li> Sharing data if it’s required by local regulatory authority of competent
                            jurisdiction, or by law, or if we believe that such action is necessary to
                            ensure, defend or enforce our rights, including exchange information with
                            other companies and organizations for the purposes of cyber security
                            protection, credit risk reduction and fraud fighting. To coordinate with
                            governmental requests, summons or court orders, or to protect other users,
                            or our assets, we reserve the right to disclose any data we consider
                            necessary or appropriate, including your profile information (i.e., name,
                            email address, etc.), usage history, and content submitted to our services.
                            .</li>

                    </ul>
                    <p>
                        Any third-party providers will be required by HALA to take all necessary steps to ensure that your data is kept secure and
                        used in accordance with HALA’s Privacy statement. However, we shall not be liable for
                        any unauthorized use of your personal data by a third-party provider.
                        However, if ordered by a court of law, HALA shall be constrained to disclose to the
                        appropriate authorities the personal information of any individual User(s). External web
                        sites, whose links may be incorporated in the HALA’s wallet application, are not under
                        the control of HALA, and HALA shall not be held responsible for the content or privacy
                        policies of any linked sites or any links containing other linked sites
                    </p>
                </section>

                <section class="privacy">
                    <h5>8. Personal Data Protection</h5>
                    <p>
                        HALA will use its best efforts to ensure that the information submitted by the customer
                        remains private and wis used only for the purpose for which it is submitted. HALA
                        follows legislative and regulatory requirements in the Kingdom of Saudi Arabia
                        standards to provide the maximum protection and privacy to your data, including using
                        of HTTPS and regularly monitoring our systems for possible vulnerabilities and attacks.
                        Any payment transactions will be protected and safeguarded by encryption. However,
                        we cannot guarantee the security of any data that you send us. There is no guarantee
                        that data may not be accessed, disclosed, altered, or destroyed by breach since the
                        internet is not completely secure.
                    </p>
                </section>

                <section class="privacy">
                    <h5>9. Statement Changes & Updates</h5>
                    <p>
                        HALA reserves the right to update and revise the Privacy Statement, at any time, to
                        ensure it complies with applicable laws and conforms to changes in business. You are
                        advised to visit the web site of HALA continually to monitor changes in the statement,
                        as the statement will be binding upon you in relation to the use of HALA’s services,
                        including HALA’s wallet. By using HALA’s wallet, and/or by providing the required
                        information, you hereby consent to the collection and use of the information disclosed
                        in accordance with the Privacy Statement of HALA.

                    </p>
                </section>

        </div>
            <div *ngIf="language === 'ar'" class="col">
                <section class="privacy ar">
                    <h5>1 .نظرة عامة </h5>
                    <p>
                        إن ﺷرﻛﺔ ھﻼ ﻟﻠﻣدﻓوﻋﺎت (ھﻼ) ھﻲ ﻣرﺧﺻﺔ ﻛﻣؤﺳﺳﺔ ﻣﺎﻟﯾﺔ EMIﻣن ﻗﺑل ﻣؤﺳﺳﺔ اﻟﻧﻘد اﻟﻌرﺑﻲ اﻟﺳﻌودي . ﺗﺣرص ھﻼ
                        ﻋﻠﻰ ﺑﯾﺎﻧﺎت وﻣﻌﻠوﻣﺎت اﻟﻣﺳﺗﺧدم وﺗﻠﺗزم ﺑﺎﻟﺣﻔﺎظ ﻋﻠﻰ ﺳرﯾﺔ وﺧﺻوﺻﯾﺔ ھذه اﻟﺑﯾﺎﻧﺎت واﺳﺗﺧداﻣﮭﺎ ﻟﻠوﺻول إﻟﻰ
                        اﻟﻣﺳﺗوى اﻟﻣطﻠوب ﻓﻲ ﺗﻘدﯾم اﻟﺧدﻣﺔ اﻟﻼزﻣﺔ ﻟﻠﻣﺳﺗﺧدم وﻓﻖ ﺗوﺟﯾﮭﺎت اﻟﺑﻧك اﻟﻣرﻛزي اﻟﺳﻌودي. ﯾﻌﺗﺑر اﺳﺗﺧدام
                        ﻣوﻗﻊ ھﻼ
                        اﻹﻟﻛﺗروﻧﻲ واﻟﺗطﺑﯾﻘﺎت ﺑﻣﺛﺎﺑﺔ ﻣواﻓﻘﺔ ﻣن اﻟﻣﺳﺗﺧدم ﻋﻠﻰ ﺑﯾﺎن اﻟﺧﺻوﺻﯾﺔ.



            </p>


          </section>
                <section class="privacy ar">
                    <h5>2. طرق ﺟﻣﻊ اﻟﺑﯾﺎﻧﺎت</h5>
                    <p>
                        ﯾﺗم ﺟﻣﻊ اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ ﺑﺷﻛل ﻏﯾر ﻣﺑﺎﺷر ﻣن ﺧﻼل ﻣﻠﻔﺎت ﺗﻌرﯾف اﻻرﺗﺑﺎط اﻟﺗﻲ ﯾﺗم ﺟﻣﻌﮭﺎ ﻋﻧد زﯾﺎرﺗك
                        ﻟﻠﻣوﻗﻊ (ﻣﻠﻔﺎت ﺗﻌرﯾف
                        اﻻرﺗﺑﺎط.)

                    </p>

                    <div class="container mt-5">
                        <table  class="w-full table-auto border-collapse border border-gray-300">
                            <thead>
                                <tr>
                                    <th class="border border-gray-300 px-4 py-2 text-center green-background" colspan="1">ﻣﻔﺗﺎح ﻣﻠﻔﺎت ﺗﻌرﯾف اﻻرﺗﺑﺎط</th>
                                    <th class="border border-gray-300 px-4 py-2 text-center green-background" colspan="2">ﻣﺟﺎل</th>
                                    <th class="border border-gray-300 px-4 py-2 text-center green-background" colspan="2">وﺻف</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of ARData">
                                    <td class="border border-gray-300 px-4 py-2 text-center" colspan="1" style="direction: ltr;">{{ item.cookieKey }}</td>
                                    <td class="border border-gray-300 px-4 py-2 text-center" colspan="2" style="direction: ltr;">{{ item.domain }}</td>
                                    <td class="border border-gray-300 px-4 py-2 text-center" colspan="2">{{ item.description }}</td>
                                </tr>
                            </tbody>
                        </table>
        </div>

                </section>
                <section class="privacy ar">
                    <h5>3. اﺳﺗﺧدام اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ</h5>
                    <p>
                        ﯾﺗم اﺳﺗﺧدام ﺑﯾﺎﻧﺎت ھﻼ اﻟﺷﺧﺻﯾﺔ ﻷﻏراض اﺳﺗﻛﻣﺎل ﻋﻣﻠﯾﺔ اﻟﺗﺳﺟﯾل وﺗﺣﺳﯾن ﺗﺟرﺑﺔ اﻟﻣﺳﺗﻔﯾد.

                        ﻗد ﺗﻘوم ھﻼ ﺑﺈرﺳﺎل ﻣﻌﻠوﻣﺎت ﺗﺳوﯾﻘﯾﺔ إﻟﻰ ﻋﻣﻼﺋﮭﺎ ﻓﯾﻣﺎ ﯾﺗﻌﻠق ﺑﺎﻟﻌروض اﻟﺗروﯾﺟﯾﺔ اﻟﺗﻲ ﺗطﻠﻘﮭﺎ ھﻼ ﻣن وﻗت
                        ﻵﺧر،أو
                        ﻋروض اﻟﺧدﻣﺎت اﻟﺗﻲ ﯾﺗم ﺗﺧﺻﯾﺻﮭﺎ واﻟﻣﺗﻌﻠﻘﺔ ﺑﻣﻌﺎﯾﯾر ﻣﻌﯾﻧﺔ ﻟﻠﻌﻣﻼء.
                        ﻟن ﯾُﺳﻣﺢ ﻟﻣﻘدﻣﻲ ﺧدﻣﺎت اﻟطرف اﻟﺛﺎﻟث ﺑﺎﺳﺗﺧدام ﺳوﻗﻧﺎ ﻣﺑﺎﺷرة وذﻟك ﺑﺎﺳﺗﺧدام ﺑﯾﺎﻧﺎﺗك اﻟﺷﺧﺻﯾﺔ ﻓﯾﻣﺎ
                        ﯾﺗﻌﻠق ﺑﺎﻟﺧدﻣﺎت
                        اﻷﺧرى اﻟﺗﻲ ﯾﻘدﻣوﻧﮭﺎ. إذا ﺗﻠﻘﯾت أي ﺗﺳوﯾق ﻣن ھذا اﻟﻘﺑﯾل ﻟم ﺗطﻠﺑﮫ ﻋﻠﻰ وﺟﮫ اﻟﺗﺣدﯾد، ﻓﯾﺟب ﻋﻠﯾك
                        إﺧﺑﺎرﻧﺎ ﻻﺗﺧﺎذ
                        اﻹﺟراء اﻟﻣﻧﺎﺳب ﻋﻠﻰ اﻟﻔور.

                    </p>

                </section>

                <section class="privacy ar">
                    <h5>4.	ﺗﺧزﯾن وإﺗﻼف اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ </h5>
                    <p>
                        ﯾﺗم ﺗﺧزﯾن اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ ﻟـ ھﻼ وﻓﻘﺎ ﻷﻧظﻣﺔ ﻣؤﺳﺳﺔ اﻟﻧﻘد اﻟﻌرﺑﻲ اﻟﺳﻌودي (SAMA) اﻟﻣﺗﻌﻠﻘﺔ ﺑﮭذا اﻷﻣر.


                    </p>


                </section>

                <section class="privacy ar">
                    <h5>5 .اﻷﺳﺎس اﻟﻘﺎﻧوﻧﻲ ﻟﺟﻣﻊ وﻣﻌﺎﻟﺟﺔ اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ</h5>
                    <p>
                        ﯾﻌﺗﻣد ﺟﻣﻊ وﻣﻌﺎﻟﺟﺔ اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ ﻋﻠﻰ ﻣواﻓﻘﺔ ﺻﺎﺣب اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ، وﯾﻣﻛن ﻟﺻﺎﺣب )ﻟﺻﺎﺣﺑﺔ( اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ إﻟﻐﺎء ﻣواﻓﻘﺗﮫ (ﻣواﻓﻘﺗﮭﺎ( ﻋﻠﻰ ﺟﻣﻊ وﻣﻌﺎﻟﺟﺔ ﺑﯾﺎﻧﺎﺗﮫ )ﺑﯾﺎﻧﺎﺗﮭﺎ( اﻟﺷﺧﺻﯾﺔ ﻓﻲ أي وﻗت ﻣﺎ ﻟم ﯾﻛن ھﻧﺎك أﺳﺎس ﻗﺎﻧوﻧﻲ آﺧر، وﻟﻠﻘﯾﺎم
                        ﺑذﻟك، ﯾﻣﻛﻧﮫ )ﯾﻣﻛﻧﮭﺎ( اﻹﺗﺻﺎل ﺑﺧدﻣﺔ ﻋﻣﻼء ھﻼ )اﻟرﻗم اﻟﻣﺟﺎﻧﻲ: 8003030122 أو ﻋﺑر اﻟﺑرﯾد اﻹﻟﻛﺗروﻧﻲ:
                        ؛(support&#64;hala.com )
                        أو ﻣن ﺧﻼل وﺣدة رﻋﺎﯾﺔ اﻟﻌﻣﻼء ﻓﻲ اﻟﻘﻧوات اﻟرﻗﻣﯾﺔ اﻟرﺳﻣﯾﺔ ﺑﺎﻟﺗواﺻل ﻣﻊ أﺣد ﻣﻣﺛﻠﻲ ﺧدﻣﺔ اﻟﻌﻣﻼء ﻟدﯾﻧﺎ. ﻛﻣﺎ ﺳﯾﺗم اﻟﺗواﺻل ﻣﻊ اﻟﻌﻣﯾل ﺑﺧﺻوص ﻗﺿﯾﺗﮫ ﺧﻼل ﺛﻼﺛﺔ (3) أﯾﺎم ﻋﻣل ﻣن ﺗﺎرﯾﺦ اﻻﺳﺗﻼم، ﻣﺎ ﻟم ﯾؤﻛد اﻟﻌﻣﯾل أن
                        اﻟﺣﺎﻟﺔ ﻗد ﺗم ﺣﻠﮭﺎ ﻣن ﻗﺑﻠﻧﺎ.

                    </p>
                </section>
                <section class="privacy ar">
                    <h5>6. ﺣﻘوق ﺻﺎﺣب اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ</h5>
                    <p>
                        ﯾﺗﻣﺗﻊ ﻋﻣﻼؤﻧﺎ ﺑﺟﻣﯾﻊ ﺣﻘوق اﻟوﺻول وﺗﺻﺣﯾﺢ وﺣذف واﻻﻋﺗراض وﺗﻘﯾﯾد اﻟﻣﻌﺎﻟﺟﺔ وإﻣﻛﺎﻧﯾﺔ ﻧﻘل اﻟﺑﯾﺎﻧﺎت
                        وإﻏﻼق ﺣﺳﺎب( ﺣﺳﺎﺑﺎت) ھﻼ اﻟﺧﺎص ﺑﮭم.


                    </p>
                    <p>إذا اﺧﺗﺎروا إﻏﻼق ﺣﺳﺎب ھﻼ اﻟﺧﺎص ﺑﮭم، ﻓﺳﺗﺗوﻗف ﻣﻌﻠوﻣﺎﺗﮭم اﻟﺷﺧﺻﯾﺔ بشكل عام ﻋن اﻟظﮭور ﻟﻶﺧرﯾن ﻓﻲ ﺧدﻣﺎﺗﻧﺎ، ﻋﻧد
                        إﻋﺎدة ﺟﻣﯾﻊ أﺟﮭزة ھﻼ وﺗﺻﻔﯾﺔ رﺻﯾد اﻟﺣﺳﺎب. ﺳﺗﻘوم ھﻼ ﺑﺷﻛل ﻋﺎم ﺑﺣذف ﺑﯾﺎﻧﺎت اﻟﺣﺳﺎب اﻟﻣﻐﻠق،
                        ﺧﻼل 90 ﯾوﻣﺎ ﻣن إﻏﻼق اﻟﺣﺳﺎب، إﻻ ﺑﺣﺎل اﻧطﺑﻘت اﻟظروف اﻟﻣذﻛورة أدﻧﺎه:

                    </p>
                    <ul>
                        <li>
                            ﻗد ﺗﺣﺗﻔظ ھﻼ ﺑﺑﯾﺎﻧﺎﺗك اﻟﺷﺧﺻﯾﺔ ﺣﺗﻰ ﺑﻌد إﻏﻼق ﺣﺳﺎﺑك، اﻣﺗﺛﺎﻻ ﻟﻠﻣﺗطﻠﺑﺎت اﻟﺗﻧظﯾﻣﯾﺔ اﻟﻣﺣﻠﯾﺔ؛ ﻟﻠوﻓﺎء ﺑﺎﻟﺗزاﻣﺎﺗﻧﺎ
                            اﻟﻘﺎﻧوﻧﯾﺔ )ﺑﻣﺎ ﻓﻲ ذﻟك طﻠﺑﺎت إﻧﻔﺎذ اﻟﻘﺎﻧون(؛ ﻟﻠﺣﻔﺎظ ﻋﻠﻰ ﺣﻣﺎﯾﺔ اﻷﻣن اﻟﺳﯾﺑراﻧﻲ، أو ﻣﻧﻊ اﻻﺣﺗﯾﺎل وإﺳﺎءة اﻻﺳﺗﺧدام )ﻋﻠﻰ ﺳﺑﯾل اﻟﻣﺛﺎل، إذا ﻗﻣﻧﺎ ﺑﺗﻘﯾﯾد ﺣﺳﺎﺑك ﺑﺳﺑب اﻧﺗﮭﺎك ﺳﯾﺎﺳﺎت ھﻼ اﻟﺧﺎﺻﺔ ﺑﻧﺎ(؛ وﺗﻧﻔﯾذ ﺷروط وأﺣﻛﺎم
                            ھﻼ. وﺑﺎﻟﺗﺎﻟﻲ، ﺳوف ﺗﺣﺗﻔظ ھﻼ ﺑﺎﻟﺑﯾﺎﻧﺎت ﻏﯾر اﻟﺷﺧﺻﯾﺔ ﺑﻌد إﻏﻼق ﺣﺳﺎﺑك.

                        </li>
                        <li>ﺳﺗظل اﻟﺑﯾﺎﻧﺎت اﻟﺗﻲ ﺗﻣت ﻣﺷﺎرﻛﺗﮭﺎ ﻣﻊ اﻵﺧرﯾن أو ﻣﻌﻠوﻣﺎت اﻟﻣﻌﺎﻣﻼت ﻣﻊ اﻵﺧرﯾن ﻣرﺋﯾﺔ ﺣﺗﻰ ﺑﻌد إﻏﻼق ﺣﺳﺎﺑك
                            أو ﺣذف اﻟﻣﻌﻠوﻣﺎت ﻣن ﻣﻠﻔك اﻟﺷﺧﺻﻲ، ﻣﻊ ﻣﻼﺣظﺔ أﻧﻧﺎ ﻻ ﻧﺗﺣﻛم ﻓﻲ اﻟﺑﯾﺎﻧﺎت اﻟﺗﻲ ﻧﺳﺧﮭﺎ اﻷﻋﺿﺎء اﻵﺧرون ﻣن
                            ﺧدﻣﺎﺗﻧﺎ.

                        </li>
                    </ul>
                </section>
                <section class="privacy ar">
                    <h5>7. ﻣﺷﺎرﻛﺔ/ ﺗﺑﺎدل اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ </h5>
                    <p>
                        ﺑﻣوﺟب ھذا اﻟﺑﯾﺎن، ﻗد ﻧﻘوم ﺑﺎﻟﻛﺷف ﻋن ﺑﯾﺎﻧﺎﺗك اﻟﺷﺧﺻﯾﺔ ﻟﺧدﻣﺎﺗﻧﺎ اﻷﺧرى داﺧل اﻟﻣﻣﻠﻛﺔ؛ و/أو أطراف ﺛﺎﻟﺛﺔ ﻓﻲ
                        اﻟظروف اﻟﺗﺎﻟﯾﺔ:


                    </p>

                    <ul>
                        <li>
                            ﻣﺷﺎرﻛﺔ اﻟﺑﯾﺎﻧﺎت ﻓﻲ ﺣﺎﻟﺔ اﻟﺗﺻﻔﯾﺔ أو اﻻﻧدﻣﺎج أو اﻟﺑﯾﻊ أو اﻟﺣراﺳﺔ اﻟﻘﺿﺎﺋﯾﺔ أو ﻧﻘل أﺻول ھﻼ إﻟﻰ اﻟﻣﺷﺗري
                            اﻟﻣﺣﺗﻣل ﻟﻠﺷرﻛﺔ وﻣﺳﺗﺷﺎرﯾﮫ.

                        </li>
                        <li>
                            ﻣﺷﺎرﻛﺔ اﻟﺑﯾﺎﻧﺎت ﻟﺿﻣﺎن ﺗوﻓر اﻟﺧدﻣﺎت وﺗﺣﺳﯾﻧﮭﺎ.
                        </li>
                        <li> ﻣﺷﺎرﻛﺔ اﻟﺑﯾﺎﻧﺎت ﻣﻊ أطراف ﺛﺎﻟﺛﺔ ﺗدﻋﻣﻧﺎ ﻓﻲ ﺗﻘدﯾم ﺧدﻣﺎﺗﻧﺎ ﻟك أو ﺗؤدي وظﺎﺋف ﻣﻌﯾﻧﺔ ﻧﯾﺎﺑﺔ ﻋﻧﺎ، ﺑﻣﺎ ﻓﻲ ذﻟك ﺧدﻣﺎت
                            دﻋم ﺗﻛﻧوﻟوﺟﯾﺎ اﻟﻣﻌﻠوﻣﺎت أو اﻟﺧدﻣﺎت اﻟﻣﮭﻧﯾﺔ.

                        </li>
                        <li> ﻣﺷﺎرﻛﺔ اﻟﺑﯾﺎﻧﺎت إذا ﻛﺎﻧت ﻣطﻠوﺑﺔ ﻣن ﻗﺑل اﻟﺳﻠطﺔ اﻟﺗﻧظﯾﻣﯾﺔ اﻟﻣﺣﻠﯾﺔ ذات اﻟﺳﻠطﺔ اﻟﻘﺿﺎﺋﯾﺔ اﻟﻣﺧﺗﺻﺔ، أو ﺑﻣوﺟب
                            اﻟﻘﺎﻧون، أو إذا ﻛﻧﺎ ﻧﻌﺗﻘد أن ھذا اﻹﺟراء ﺿروري ﻟﺿﻣﺎن ﺣﻘوﻗﻧﺎ أو اﻟدﻓﺎع ﻋﻧﮭﺎ أو إﻧﻔﺎذھﺎ، ﺑﻣﺎ ﻓﻲ ذﻟك ﺗﺑﺎدل اﻟﻣﻌﻠوﻣﺎت ﻣﻊ اﻟﺷرﻛﺎت واﻟﻣﻧظﻣﺎت اﻷﺧرى ﻷﻏراض ﺣﻣﺎﯾﺔ اﻷﻣن اﻟﺳﯾﺑراﻧﻲ واﻟﺣد ﻣن ﻣﺧﺎطر اﻻﺋﺗﻣﺎن وﻣﻛﺎﻓﺣﺔ
                            اﻻﺣﺗﯾﺎل.


                            للتنسيق مع الطلبات الحكومية أو الاستدعاءات أو أوامر المحكمة، أو لحماية المستخدمين الآخرين أو أصولنا، نحتفظ بالحق في الكشف عن أي بيانات نعتبرها ضرورية أو مناسبة، بما في ذلك معلومات ملفك الشخصي (مثل الاسم وعنوان البريد الإلكتروني وما إلى ذلك) وسجل الاستخدام والمحتوى المقدم إلى خدماتنا.
                        </li>
                    </ul>
                    <p>
                        وﺳﺗطﻠب ھﻼ ﻣن أي ﻣن ﻣﻘدﻣﻲ ﺧدﻣﺎت اﻟطرف اﻟﺛﺎﻟث اﺗﺧﺎذ ﺟﻣﯾﻊ اﻟﺧطوات اﻟﻼزﻣﺔ ﻟﺿﻣﺎن اﻟﺣﻔﺎظ ﻋﻠﻰ أﻣﺎن ﺑﯾﺎﻧﺎﺗك واﺳﺗﺧداﻣﮭﺎ وﻓﻘﺎ ﻟﺑﯾﺎن اﻟﺧﺻوﺻﯾﺔ اﻟﺧﺎص ﺑـ ھﻼ. وﻣﻊ ذﻟك، ﻟن ﻧﻛون ﻣﺳؤوﻟﯾن ﻋن أي اﺳﺗﺧدام ﻏﯾر ﻣﺻرح ﺑﮫ ﻟﺑﯾﺎﻧﺎﺗك اﻟﺷﺧﺻﯾﺔ ﻣن ﻗﺑل ﻣﻘدﻣﻲ ﺧدﻣﺎت اﻟطرف اﻟﺛﺎﻟث. وﻣﻊ ذﻟك، إذا أﻣرت اﻟﻣﺣﻛﻣﺔ ﺑذﻟك، ﻓﺳﺗﻛون ھﻼ ﻣﻘﯾدة ﺑﺎﻟﻛﺷف ﻟﻠﺳﻠطﺎت
                        اﻟﻣﺧﺗﺻﺔ ﻋن اﻟﻣﻌﻠوﻣﺎت اﻟﺷﺧﺻﯾﺔ ﻷي ﻣﺳﺗﺧدم ﻓردي أو ﻣﺳﺗﺧدﻣﯾن أﻓراد.

                    </p>
                    <p>ﻻ ﺗﺧﺿﻊ اﻟﻣواﻗﻊ اﻹﻟﻛﺗروﻧﯾﺔ اﻟﺧﺎرﺟﯾﺔ، اﻟﺗﻲ ﻗد ﯾﺗم دﻣﺞ رواﺑطﮭﺎ ﻓﻲ ﺗطﺑﯾق ﻣﺣﻔظﺔ ھﻼ ﻟﺳﯾطرة ھﻼ، وﻟن ﺗﺗﺣﻣل ھﻼ
                        اﻟﻣﺳؤوﻟﯾﺔ ﻋن ﻣﺣﺗوى أو ﺳﯾﺎﺳﺎت اﻟﺧﺻوﺻﯾﺔ ﻷي ﻣواﻗﻊ ﻣرﺗﺑطﺔ أو أي رواﺑط ﺗﺣﺗوي ﻋﻠﻰ ﻣواﻗﻊ ﻣرﺗﺑطﺔ أﺧرى.

                    </p>

                </section>

                <section class="privacy ar">
                    <h5>8 . ﺣﻣﺎﯾﺔ اﻟﺑﯾﺎﻧﺎت اﻟﺷﺧﺻﯾﺔ </h5>
                    <p>
                        ﺳﺗﺑذل ھﻼ ﻗﺻﺎرى ﺟﮭدھﺎ ﻟﺿﻣﺎن ﺑﻘﺎء اﻟﻣﻌﻠوﻣﺎت اﻟﻣﻘدﻣﺔ ﻣن ﻗﺑل اﻟﻌﻣﯾل تظل ﺧﺎﺻﺔ واﺳﺗﺧداﻣﮭﺎ ﻓﻘط ﻟﻠﻐرض اﻟذي ﺗم ﺗﻘدﯾﻣﮭﺎ
                        ﻣن أﺟﻠﮫ. ﺗﺗﺑﻊ ھﻼ اﻟﻣﺗطﻠﺑﺎت اﻟﺗﺷرﯾﻌﯾﺔ واﻟﺗﻧظﯾﻣﯾﺔ ﻓﻲ ﻣﻌﺎﯾﯾر اﻟﻣﻣﻠﻛﺔ اﻟﻌرﺑﯾﺔ اﻟﺳﻌودﯾﺔ ﻟﺗوﻓﯾر أﻗﺻﻰ ﻗدر ﻣن اﻟﺣﻣﺎﯾﺔ
                        واﻟﺧﺻوﺻﯾﺔ ﻟﺑﯾﺎﻧﺎﺗك، ﺑﻣﺎ ﻓﻲ ذﻟك اﺳﺗﺧدام HTTPS وﻣراﻗﺑﺔ أﻧظﻣﺗﻧﺎ ﺑﺎﻧﺗظﺎم ﺑﺣﺛﺎ ﻋن ﻧﻘﺎط اﻟﺿﻌف واﻟﮭﺟﻣﺎت اﻟﻣﺣﺗﻣﻠﺔ.

                    </p>


                    <p>
                        ﺳﯾﺗم ﺣﻣﺎﯾﺔ أي ﻣﻌﺎﻣﻼت دﻓﻊ وﺣﻣﺎﯾﺗﮭﺎ ﻋن طرﯾق اﻟﺗﺷﻔﯾر. وﻣﻊ ذﻟك، ﻻ ﯾﻣﻛﻧﻧﺎ ﺿﻣﺎن أﻣﺎن أي ﺑﯾﺎﻧﺎت ﺗرﺳﻠﮭﺎ إﻟﯾﻧﺎ. ﻟﯾس ھﻧﺎك ﻣﺎ ﯾﺿﻣن ﻋدم إﻣﻛﺎﻧﯾﺔ اﻟوﺻول إﻟﻰ اﻟﺑﯾﺎﻧﺎت أو اﻟﻛﺷف ﻋﻧﮭﺎ أو ﺗﻐﯾﯾرھﺎ أو ﺗدﻣﯾرھﺎ ﻋن طرﯾق اﻻﺧﺗراق ﻧظرا ﻷن
                        اﻹﻧﺗرﻧت ﻟﯾس آﻣﻧﺎ ﺗﻣﺎﻣﺎ.

                    </p>
                </section>

                <section class="privacy ar">
                    <h5>9. ﺗﻐﯾﯾرات وﺗﺣدﯾﺛﺎت اﻟﺑﯾﺎن</h5>
                    <p> ﺗﺣﺗﻔظ ھﻼ ﺑﺎﻟﺣق ﻓﻲ ﺗﺣدﯾث وﻣراﺟﻌﺔ ﺑﯾﺎن اﻟﺧﺻوﺻﯾﺔ، ﻓﻲ أي وﻗت، ﻟﻠﺗﺄﻛد ﻣن اﻣﺗﺛﺎﻟﮫ ﻟﻠﻘواﻧﯾن اﻟﻣﻌﻣول ﺑﮭﺎ وﺗواﻓﻘﮫ ﻣﻊ اﻟﺗﻐﯾﯾرات ﻓﻲ اﻷﻋﻣﺎل. ﻧﻧﺻﺣك ﺑزﯾﺎرة ﻣوﻗﻊ ھﻼ اﻹﻟﻛﺗروﻧﻲ ﺑﺷﻛل ﻣﺳﺗﻣر ﻟﻣراﻗﺑﺔ اﻟﺗﻐﯾﯾرات ﻓﻲ اﻟﺑﯾﺎن، ﺣﯾث ﺳﯾﻛون اﻟﺑﯾﺎن ﻣﻠزﻣﺎ ﻋﻠﯾك ﻓﯾﻣﺎ ﯾﺗﻌﻠق ﺑﺎﺳﺗﺧدام ﺧدﻣﺎت ھﻼ، ﺑﻤﺎ ﻓﻲ ذﻟﻚ ﻣﺤﻔﻈﺔ ھﻼ. ﺑﺎﺳﺘﺨﺪام ﻣﺤﻔﻈﺔ ھﻼ و/ أو ﻣﻦ ﺧﻼل ﺗﻘﺪﯾﻢ اﻟﻤﻌﻠﻮﻣﺎت
                        اﻟﻤﻄﻠﻮﺑﺔ، ﻓﺈﻧﻚ ﺗﻮاﻓﻖ ﺑﻤﻮﺟﺒﮫ ﻋﻠﻰ ﺟﻤﻊ واﺳﺘﺨﺪام اﻟﻤﻌﻠﻮﻣﺎت اﻟﺘﻲ ﺗﻢ اﻟﻜﺸﻒ ﻋﻨﮭﺎ وﻓﻘﺎ ﻟﺒﯿﺎن اﻟﺨﺼﻮﺻﯿﺔ اﻟﺨﺎص ﺑـ ھﻼ.

                    </p>
                </section>

      </div>

    </div>
  </div>
